/**
 * 恢复滚动条到顶部
 */
export default {
  created () {
    window.scrollTo(0, 0)
  }
}
